// TDI2 DI-Core - Main entry point

export const TDI2_VERSION = "0.1.0";

// Export decorators
export * from './decorators.js';
